export default __webpack_public_path__ + "static/media/step-image.aef03d13.png";